import {
	ArrowBackOutlined,
	Close,
	DoNotDisturbOutlined,
} from "@mui/icons-material";
import {
	Box,
	Button,
	CircularProgress,
	Divider,
	IconButton,
	Stack,
	Typography,
} from "@mui/material";
import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { addUserToMessageViewedList } from "../../../actions/util";
import { useCurrentUser } from "../../../hooks/useCurrentUser";
import { ESRState, Thread } from "../../../types/data";
import { DrawerContainer } from "../DrawerContainer";
import { Comment } from "./Comment";
import { NewCommentEntry } from "./NewCommentEntry";
import { Recipients } from "./Recipients";

type Props = {
	thread: Thread | null;
	open: boolean;
	loading: boolean;
	onBack: () => void;
	onClose: () => void;
};
export const ThreadDetail: FC<Props> = ({
	loading,
	open,
	thread,
	onBack,
	onClose,
}) => {
	const { esrId = "" } = useParams();
	const dispatch = useDispatch();
	const [user, setUser] = useCurrentUser();
	const navigate = useNavigate();

	// useEffect(() => {
	// 	if (thread?.question_id) {
	// 		navigate(`/esr/${esrId}/redirect/${thread.question_id}`);
	// 	}
	// }, [esrId, thread?.question_id]);

	const current_user = useSelector((state: ESRState) => state.current_user);
	useEffect(() => {
		// Check if current user in messages.viewer_ids list
		// if current user is not the sender id and current user not in viewer_ids list
		// then dispatch to add the user to viewers list
		thread?.messages.forEach((message) => {
			if (message?.sender_id !== current_user?.email) {
				if (!message?.viewer_ids?.includes(current_user?.email)) {
					dispatch(addUserToMessageViewedList(message.id, esrId));
				}
			}
		});
	}, [esrId, thread?.question_id]);

	return (
		<DrawerContainer open={open} onClose={onClose}>
			<Box
				sx={{
					width: 500,
					height: "100%",
					display: "flex",
					flexDirection: "column",
					background: "rgba(0, 62, 98, 0.02)",
				}}
			>
				{loading ? (
					<Stack
						sx={{
							position: "absolute",
							left: 0,
							right: 0,
							top: 0,
							bottom: 0,
							zIndex: 1,
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						<CircularProgress size={100} />
					</Stack>
				) : !thread ? (
					<Stack
						sx={{
							height: "100%",
							alignItems: "center",
							justifyContent: "center",
							color: 'darkred'
						}}
					>
						<DoNotDisturbOutlined />
						You don’t have permission to view this thread.
					</Stack>
				) : (
					<>
						<Box
							sx={{
								height: 60,
								display: "flex",
								flexDirection: "row",
								alignItems: "center",
								px: "24px",
								justifyContent: "space-between",
								background: "rgba(0, 62, 98, 0.02)",
							}}
						>
							<Button
								variant="text"
								startIcon={<ArrowBackOutlined />}
								onClick={onBack}
							>
								back
							</Button>
							<Typography sx={{ fontWeight: 500, fontSize: 14 }}>
								Comments ({thread.messages.length})
							</Typography>
							<IconButton aria-label="close threads" onClick={onClose}>
								<Close />
							</IconButton>
						</Box>
						<Box
							sx={{
								p: "24px",
								background: "rgba(0, 62, 98, 0.02)",
							}}
						>
							<Box
								sx={{
									display: "flex",
									alignItems: "center",
								}}
							>
								{thread.question_id !== null && (
									<>
										<Typography
										component="span"
										fontSize={14}
										fontWeight={500}
										my="8px"
										sx={{ color: "green", ml: 0, mr: 1 }}
										>
												ESR#{(thread?.addendum_label.length > 0)? thread?.addendum_id : thread?.esr_id}{(thread?.addendum_label.length > 0)? thread.addendum_label : ""} 
										</Typography>
										<Typography
											sx={{
												color: "rgba(0, 0, 0, 0.5)",
												fontSize: 14,
												fontWeight: 500,
											}}
										>
											Problem Description
										</Typography>
									</>
								)}
								{thread.question_id === null && (
									<>
										<Typography
										component="span"
										fontSize={14}
										fontWeight={500}
										my="8px"
										sx={{ color: "green", ml: 0, mr: 1 }}
										>
											ESR#{(thread?.addendum_label.length > 0)? thread?.addendum_id : thread?.esr_id}{(thread?.addendum_label.length > 0)? thread.addendum_label : ""} 
										</Typography>
										<Typography
											sx={{
												color: "rgba(0, 0, 0, 0.5)",
												fontSize: 14,
												fontWeight: 500,
											}}
										>
											Message
										</Typography>
									</>

								)}
								<Box sx={{ flex: 1 }} />
								{/* {
									thread.question_id !== null &&
									<>
										<Typography
											sx={{
												color: "rgba(0, 0, 0, 0.3)",
												fontSize: 12,
												fontWeight: 400,
											}}
										>
											Resolved?
										</Typography>
										<Switch
											disabled={thread.creator_id !== user?.email}
											checked={thread.resolved}
											onChange={toggleResolvedStatus}
										/>
									</>
								} */}
							</Box>
							<Typography
								sx={{
									fontSize: 14,
									fontWeight: 500,
									py: "12px",
								}}
							>
								{thread.subject}
							</Typography>
							<Typography
								fontSize={12}
								fontWeight={400}
								color="#73767d"
								sx={{ marginBottom: "5%" }}
							>
								From: {thread.creator_id}
							</Typography>
							<Recipients thread={thread} />
						</Box>

						<Divider />

						<Box sx={{ flex: 1, overflow: "scroll" }}>
							{(thread.messages ?? []).map((message) => (
								<Comment key={message.id} {...message} />
							))}
						</Box>
						<NewCommentEntry threadId={thread.id} questionId={thread.question_id}/>
					</>
				)}
			</Box>
		</DrawerContainer>
	);
};
